/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';

import LeftMenuPanelPopup from '../Menu/LeftMenuPanelPopup';
import UserRightMenu from '../Menu/UserRightMenu';

const Header = () => {
    return (
        <header id="header">
            <nav className="navbar navbar-expand-lg bg-white shadow-sm">
                <div className="container-fluid px-lg-5">
                    <button
                        className="p-0 text-black bg-transparent border-0 me-3"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasMainNav"
                        aria-controls="offcanvasMainNav"
                    >
                        <span className="d-block material-symbols-outlined fs-2">menu</span>
                    </button>
                    <Link className="navbar-brand p-0 me-3 me-md-4 me-lg-5" to="/dashboard">
                        <img src={`${process.env.PUBLIC_URL}/assets/img/saludti-logo.png`} alt="Saludti" className="img-fluid" />
                    </Link>
                    <form className="d-none d-md-block position-relative" role="search">
                        <input
                            className="form-control fs-sm body-bg px-3 border-0 rounded-10 shadow-none me-2"
                            type="text"
                            placeholder="Search"
                            aria-label="Search"
                        />
                        <button
                            className="p-0 bg-transparent border-0 position-absolute top-50 end-0 translate-middle-y me-3"
                            type="submit"
                        >
                            <span className="d-block material-symbols-outlined">search</span>
                        </button>
                    </form>
                    <ul className="navbar-nav flex-row align-items-center gap-3 ms-auto">
                        <li className="nav-item d-block d-md-none search">
                            <Link to="#" className="d-block">
                                <span className="d-block material-symbols-outlined">search</span>
                            </Link>
                        </li>
                        <li className="nav-item notification">
                            <Link to="/notifications" className="position-relative">
                                <span className="d-block material-symbols-outlined">notifications</span>
                                <span className="has-notification d-block position-absolute end-0 bg-primary border border-2 border-white rounded-circle"></span>
                            </Link>
                        </li>
                        <li className="nav-item dropdown">
                            <UserRightMenu />
                        </li>
                    </ul>
                </div>
            </nav>
            <LeftMenuPanelPopup />
        </header>
    );
};

export default Header;

